import { lightFormat } from 'date-fns'

export const FormatDate = (value: Date) => {
   
    let date_string = lightFormat(new Date(value), 'dd/MM/yyyy');

    return date_string;
}